import React, { useRef } from 'react';
// import ReactDOM from 'react-dom/client';
import './TodayView.scss';

// import styles from './TodayView.scss';
// import classNames from 'classnames/bind';

// import classNames from 'classnames/bind';

// import {NumericFormat} from 'react-number-format';
import Adsense970250 from 'components/adsense/Adsense970250';
// import Adsense300250 from 'components/adsense/Adsense300250';
// import Adsense72890 from 'components/adsense/Adsense72890';

// const cx = classNames.bind(styles);

import {Link} from 'react-router-dom';
import {NumericFormat} from 'react-number-format';
import dayjs from 'dayjs';
import html2canvas from 'html2canvas';


const TodayStocksItem = ({
  stockName, stockCode, upRvn, trscAmt, price, cnt0, cnt, themaStocksSize
}) => {

  return (
    <div className="stock-row">
      <span className="stock-name">
        <a href={`https://finance.naver.com/item/board.naver?code=${stockCode}`} target="_blank">{stockName}
        {themaStocksSize > 1 && (cnt === 1 || cnt === 2 || cnt === 3 ) && (cnt0 === 0) && upRvn > 20 ? <span class="stamp-label stamp1">대장주</span> : <></>}
        {upRvn > 29.4 ? <span class="stamp-label stamp2">상한가</span> : <></>}
        </a>
      </span>
      <span className="stock-price">
        <NumericFormat 
          value={price} displayType={'text'} 
          thousandSeparator={true} 
          prefix={''}
          suffix={'원'}
        />
      </span>
      <span className="stock-change">
        <NumericFormat 
          value={upRvn} displayType={'text'} 
          thousandSeparator={true} 
          prefix={'+'}
          suffix={'%'}
        />
      </span>
      <span className="stock-volume">
        <NumericFormat 
          value={
            // Math.floor(Number(trscAmt)/100)
            trscAmt
          } displayType={'text'} 
          thousandSeparator={true} 
          suffix={'주'}
        />
      </span>

      {/* <li>
        <a href={`https://finance.naver.com/item/main.nhn?code=${stockCode}`} 
          target="_blank" rel="noopener noreferrer"
        >{stockName}</a>
      </li> */}
    </div>
  )
};

const TodayItem = ({
  cnt, thema, themaCtt, themaStocks, themaNews
}) => {

  const stockList = themaStocks.map((data, cnt0) => {
    const {종목명, 종목코드, 등락, 거래량, 현재가} = data;

    return <TodayStocksItem key={cnt0}
      stockName={종목명}
      stockCode={종목코드}
      upRvn={등락}
      trscAmt={거래량}
      price={현재가}
      cnt0={cnt0}
      cnt={cnt}
      themaStocksSize={themaStocks.length}
    />
  });

  const newsList = themaNews.map((data, cnt1) => {
    const {뉴스제목, 뉴스주소} = data;

    return <>
      <div className="news-item" key={cnt1}>
        <a href={뉴스주소} target="_blank" class="underline">{뉴스제목}</a>
      </div>
    </>
  });

  return (
    <>
    <div className="theme-section">
      <h3>{thema}</h3>
      <p>{themaCtt}</p>
      <div className="news-list">{newsList}</div>
      <div className="stock-table">
        <div className="stock-header">
          <span className="stock-name-header">관련종목</span>
          <span className="stock-price-header">현재가</span>
          <span className="stock-change-header">등락</span>
          <span className="stock-volume-header">거래량</span>
        </div>
        {stockList}
      </div>
    </div>
    {/* {cnt > 0 && cnt % 2 == 0 ? <Adsense300250/> : <></>} */}
    </>
  )
};

const TodayView = ({todayList, isLastThema, setIsLastThema, allList}) => {
  
  const {오늘의코멘트, 테마목록, 날짜} = todayList;
  
  const list = 테마목록===undefined ? [] : 테마목록.map((data, cnt) => {
    const {테마, 테마내용, 테마종목들, 테마관련기사들} = data;

    return <TodayItem cnt={cnt+1}
      thema={테마}
      themaCtt={테마내용}
      themaStocks={테마종목들}
      themaNews={테마관련기사들}
    />
  });

  const list2 = allList===undefined ? [] : allList.map((data, cnt) => {
    const {날짜, 오늘의키워드} = data;

    return <div className="past-theme-item">
      <Link to={`/finance/${날짜}`} key={cnt}>
        {`${dayjs(날짜, 'YYYYMMDD').format('YYYY.MM.DD')} - ${오늘의키워드}`}
      </Link>
    </div>
  });

  const captureRef = useRef();
  const handleCapture = async () => {
    if (!captureRef.current) return;

    const canvas = await html2canvas(captureRef.current);
    const imgData = canvas.toDataURL('image/png');

    // 이미지 다운로드
    const link = document.createElement('a');
    link.href = imgData;
    link.download = 'screenshot.png';
    link.click();
  };
  
  return (
    <div className="theme-stocks-page" ref={captureRef}>
      <div id="t"></div>
      <a href="#t" class="to-top-button">맨위로</a>
      <div className="theme-stocks-header">
        <h1>📈 강세 테마주 정리</h1>
        <div className="header-menu">
          {/* <a href="/">홈</a> */}
          {/* <div className="menu-item">지난 테마</div> */}
          {/* <a href="/about">소개</a> */}

          <div className="menu">
            <div className="menu-item past-themes" onClick={() => setIsLastThema()}>
              📅 지난 테마
            </div>
          </div>
        </div>
        <div className={`past-theme-list ${isLastThema ? "open" : ""}`}>
          {list2}
        </div>
      </div>
      <div className="theme-stocks-content">
        <h2 className="page-title">{dayjs(날짜, 'YYYYMMDD').format('YYYY년 MM월 DD일') + " - 강세 테마주 정리"}</h2>
        <p className="daily-comment">{오늘의코멘트}</p>
        <Adsense970250/>
        {list}
      </div>

      <footer class="text-center text-sm text-gray-500 mt-12 mb-4">
        <p onClick={handleCapture}>© 2025 오늘의 강세 테마주 정리. All rights reserved.</p>
        {/* <p>이 사이트의 모든 콘텐츠는 정보 제공을 목적으로 하며 무단 복제를 금합니다.</p> */}
        {/* <p>문의: <a href="mailto:aliswell86@naver.com" class="underline">aliswell86@naver.com</a></p> */}
      </footer>


    </div>
  );
}

export default TodayView;